
export const INVENTORY_COOLDOWN_TS_KEY = 'ybabecieci';

export const COOLDOWN_HOURS = 12;
export const COOLDOWN_RANGE = COOLDOWN_HOURS * 60 * 60 * 1000;

export const SPACESHIP_PASS_COOLDOWN = 20 * 60 * 60 * 1000;
